// removed by extract-text-webpack-plugin
module.exports = {"aliCard":"Card__aliCard__gQ5KG","mainDiv":"Card__mainDiv__icO_t","aliImg":"Card__aliImg__3yNWC","container":"Card__container__1CaDo","aliRow":"Card__aliRow__1h5lL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Card/Card.css
// module id = 102
// module chunks = 17